import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { TRANSLATIONS_PR } from "./locales/pr/translation";
import { TRANSLATIONS_EN } from "./locales/en/translation";
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      en: {
        translation: TRANSLATIONS_EN,
      },
      pr: {
        translation: TRANSLATIONS_PR,
      },
    },
    lng: "pr", // if you're using a language detector, do not define the lng option
    fallbackLng: "en",

    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });

export default i18n;
